document.addEventListener("DOMContentLoaded", function () {

    const slider = document.querySelector(".customer-reviews");
    if (!slider) return;

    new Swiper(slider, {
        spaceBetween: 13,
        slidesPerGroup: 1,
        watchOverflow: true,

        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },

        breakpoints: {
            0: {
                slidesPerView: 1
            },
            768: {
                slidesPerView: 1
            },
            1024: {
                slidesPerView: 2.2
            }
        }

    });

});





document.addEventListener("DOMContentLoaded", function () {
    const tabSection = document.querySelector(".hydration-core__wrapper");

    if (!tabSection) return;

    const tabLinks = tabSection.querySelectorAll(".hydration-core__text ul li a");
    const tabItems = tabSection.querySelectorAll(".hydration-core__item");

    function updateTabNumbers() {
        tabLinks.forEach((link, index) => {
            const existingEm = link.querySelector("em");

            if (existingEm) {
                existingEm.remove();
            }

            if (link.classList.contains("active")) {
                const em = document.createElement("em");
                em.textContent = `(${index + 1})`;
                link.prepend(em);
            }
        });
    }

    function activateTab(targetTab, clickedLink) {
        tabLinks.forEach((link) => {
            link.classList.remove("active");
        });

        tabItems.forEach((item) => {
            item.classList.remove("active");
        });

        clickedLink.classList.add("active");

        const targetContent = tabSection.querySelector(
            `.hydration-core__item[tab-content="${targetTab}"]`
        );

        if (targetContent) {
            targetContent.classList.add("active");
        }

        updateTabNumbers();
    }
    tabLinks.forEach((link) => {
        link.addEventListener("click", function (event) {
            event.preventDefault();

            const targetTab = this.getAttribute("data-tab");
            activateTab(targetTab, this);
        });
    });
    updateTabNumbers();
});




document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.comparison__img');
    const rightImg = document.querySelector('.comparison__right-wrap');
    const icon = document.querySelector('.comparison__img-icon');
    const line = document.querySelector('.comparison__img-line');

    if (!container || !rightImg || !icon || !line) return;

    let isDragging = false;

    // Slide function
    const slide = (e) => {
        if (!isDragging) return; // Jodi click kora na thake, tobe kaj korbe na

        const rect = container.getBoundingClientRect();
        let x;

        // Mouse ba Touch position handle kora
        if (e.type.includes('touch')) {
            x = e.touches[0].clientX - rect.left;
        } else {
            x = e.clientX - rect.left;
        }

        // Boundary (0-100%)
        if (x < 0) x = 0;
        if (x > rect.width) x = rect.width;

        const position = (x / rect.width) * 100;

        // UI Update
        rightImg.style.clipPath = `inset(0 0 0 ${position}%)`;
        line.style.left = `${position}%`;
        icon.style.left = `${position}%`;
    };

    // Drag start
    const startDragging = () => isDragging = true;
    // Drag stop
    const stopDragging = () => isDragging = false;

    // Desktop Events
    container.addEventListener('mousedown', startDragging);
    window.addEventListener('mouseup', stopDragging); // Window-te mouse chharleo stop hobe
    container.addEventListener('mousemove', slide);

    // Mobile Events
    container.addEventListener('touchstart', startDragging);
    window.addEventListener('touchend', stopDragging);
    container.addEventListener('touchmove', slide);
});